import apiService from '../Api'
import { IEventCost, IEventCostSyncItem, IEventCostSyncResponse } from './interfaces'

export default class EventCostService {
  async list(eventId: number): Promise<{ total: number; data: IEventCost[] }> {
    return apiService.get(`/events/${eventId}/costs`).then((r) => r.data)
  }

  async sync(eventId: number, costs: IEventCostSyncItem[]): Promise<IEventCostSyncResponse> {
    return apiService.put(`/events/${eventId}/costs/sync`, { costs }).then((r) => r.data)
  }

  async delete(eventId: number, id: number): Promise<void> {
    return apiService.delete(`/events/${eventId}/costs/${id}`)
  }
}
